export default __webpack_public_path__ + "58f75f10ea970a805f785b1ca0b7febe.png";